








import { Component, Vue, Watch } from 'vue-property-decorator'

@Component({
    name: 'Toast',
})
export default class Toast extends Vue {
    message: string = '' // message传空字符串可以隐藏toast
    visible: boolean = false
    time: number = 3000
    timeId: any = ''
    // autoClose: boolean = true

    @Watch('visible')
    isVisibleTrue(current: boolean) {
        clearTimeout(this.timeId)
        if (current) {
            this.timeId = setTimeout(() => {
                this.visible = false
            }, this.time)
        }
    }
}
